import getId from "@irati/utils/id";
export default (function (isRewardDisabled, idProps) { return [
    {
        to: "/account/my-recognition",
        label: "recognition.account.menu.recognition",
        id: getId("myRecognitionLink", idProps)
    },
    !isRewardDisabled && {
        to: "/account/my-rewards",
        label: "recognition.account.menu.rewards",
        id: getId("myRewardsLink", idProps)
    },
    {
        to: "/account/my-trophies",
        label: "recognition.account.menu.trophies",
        id: getId("myTrophiesLink", idProps)
    }
]; });
